import { ILocalStorageKey, ICookiePreferenceType } from "shared/types";
import { LocalStorageService } from "./LocalStorageService";

// ttl is 365 days or 31536000 seconds
const TTL = 31536000;

export class CookieService {
  static userHasSetCookiePreference = () =>
    LocalStorageService.hasItem(ILocalStorageKey.cookiePreference);

  static userCookiePreference = () =>
    LocalStorageService.getItem(
      ILocalStorageKey.cookiePreference
    ) as ICookiePreferenceType | null;

  static acceptAllCookies = () => {
    LocalStorageService.setItem(
      ILocalStorageKey.cookiePreference,
      ICookiePreferenceType.acceptAll,
      TTL
    );
  };

  static denyAnalyticalCookies = () => {
    LocalStorageService.setItem(
      ILocalStorageKey.cookiePreference,
      ICookiePreferenceType.denyAnalytical,
      TTL
    );
  };
}
